// Użytkownicy z dostępem do raportu "Magazyn Warszawa - czasy obsługi".
// Ta sama lista jest w backendzie: Transport-Back/raportMagazynWarszawaRoutes.js
export const RAPORT_MW_USERS = ["Maciej", "plomza"];

export const isRaportMwUser = (username) => RAPORT_MW_USERS.includes(username);
